module.exports = __webpack_public_path__ + "img/00banner full color.2ebb9c1c.webp";